<div>
  <app-proj-sidebar></app-proj-sidebar>
  <div class="container-fluid">
    <div class="project-content">
      <nz-collapse nzGhost>
        <nz-collapse-panel
          [nzHeader]="projectHeader"
          [nzActive]="false"
        >
        <h6 class="project-title">Description</h6>
        {{ project_description }}
        </nz-collapse-panel>
      </nz-collapse>
      <ng-template #projectHeader>
        <h6 class="project-title">
          {{ project_name }}
          <button nz-button nzShape="circle" nzType="text" nzSize="small" (click)="openProjectDialog(); $event.stopPropagation()">
            <span nz-icon nzType="edit" nzTheme="outline" nz-tooltip nzTooltipTitle="Edit project"></span>
          </button>
        </h6>
      </ng-template>
    </div>

    <app-parameter-glossary></app-parameter-glossary>
    
    <button nz-button nzType="default" nz-dropdown [nzDropdownMenu]="addJobMenu" nzTrigger="click">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      <span nz-icon nzType="down" nzTheme="outline"></span>
    </button>
    <nz-dropdown-menu #addJobMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="addJob()">Add existing job</li>
        <li nz-menu-item (click)="submitNewJob()">Submit new job</li>
      </ul>
    </nz-dropdown-menu>
  </div>
  <router-outlet></router-outlet>

</div>
